import React from 'react';

import { theme } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { EpdState } from '@app/models/orders';
import { StatusTag } from '@components/StatusTag';

interface IProps {
  state: EpdState;
}

export const EpdStatusTag: React.FC<IProps> = ({ state }) => {
  const epdT = useTranslation(NSKeys.epd);
  const { token } = theme.useToken();
  const color =
    state === EpdState.Error
      ? token.colorError
      : state === EpdState.Completed
      ? token.colorSuccess
      : [EpdState.NeedsData, EpdState.RevokeNeedsSigner].includes(state)
      ? token.colorWarning
      : [EpdState.Cancelled, EpdState.Revoked].includes(state)
      ? token.colorTextSecondary
      : token.colorPrimary;
  return <StatusTag color={color} name={epdT.t(`states.${state}` as const)} />;
};
